export { OPERATIONAL_EVENT_TYPE } from '@atlaskit/analytics-gas-types';
export var source = 'crossFlowProvider';
export var errorBoundaryAction = 'errorCaught';
export var errorBoundaryActionSubject = 'errorBoundary';
export var crossFlowActionSubject = 'crossFlowSupport';
export var uiInitialized = 'uiInitialized';
export var openInvoked = 'openInvoked';